import { render, staticRenderFns } from "./InputRange.vue?vue&type=template&id=588123bc&scoped=true&"
import script from "./InputRange.vue?vue&type=script&lang=ts&"
export * from "./InputRange.vue?vue&type=script&lang=ts&"
import style0 from "./InputRange.vue?vue&type=style&index=0&id=588123bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588123bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
